module.exports = __webpack_public_path__ + "img/下载.df94308b.svg";